import { useEffect, useMemo, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router'
import { UrgencyPriorityOptionDTO, UrgencySexOptionDTO } from '../../dto/urgencySummary/UrgencySummaryDTO'
import UrgencyDetailView from './components/UrgencyDetailView'
import { UrgencyGroupBy } from './components/UrgencyGroupedTable'
import UrgencySummaryPage from './components/UrgencySummaryPage'
import { UrgencyMeasure } from './urgencyAnalysis'
import { URGENCY_TAB } from './urgencyTabs'
import useUrgencySummaryData from './useUrgencySummaryData'
import '../../components/summary/Summary.scss'
import './UrgencySummary.scss'

/** Sin opciones de sexo (todavía no llegaron): el filtro queda vacío. Constante para no cambiar de identidad en cada render. */
const NO_SEXES: UrgencySexOptionDTO[] = []
const NO_PRIORITIES: UrgencyPriorityOptionDTO[] = []

/**
 * Atenciones de urgencia (reemplaza a `summaryurgencyattentionsview` de Vaadin).
 *
 * Contenedor de dos rutas: el resumen (`/summaryurgencyattentionsview`) y el detalle (`…/detail`). Los datos del
 * resumen viven acá para que, al volver del detalle, se conserven los filtros, el resultado y el agrupamiento de la tabla.
 * Se registra con `/*` en `routeComponents` para que el detalle quede adentro del Dashboard, con su menú y encabezado.
 */
export default function UrgencySummaryView() {
  const { pathname } = useLocation()
  // Ruta del resumen, estemos en el resumen o en el detalle
  const basePath = useMemo(() => pathname.replace(/\/(detail)?\/?$/, ''), [pathname])
  const data = useUrgencySummaryData()
  const [groupBy, setGroupBy] = useState<UrgencyGroupBy>('template')
  // La pestaña elegida y la medida de los gráficos no se pierden al cambiar los filtros ni al volver del detalle
  const [tab, setTab] = useState<number>(URGENCY_TAB.evolution)
  const [measure, setMeasure] = useState<UrgencyMeasure>('arrivals')
  const { ensureLoaded } = data

  // La primera consulta se pide recién al abrir el resumen (no si se llega al detalle y se redirige)
  const onSummary = pathname === basePath || pathname === `${basePath}/`
  useEffect(() => {
    if (onSummary) ensureLoaded()
  }, [onSummary, ensureLoaded])

  return (
    <Routes>
      <Route
        index
        element={(
          <UrgencySummaryPage
            data={data}
            groupBy={groupBy}
            onGroupByChange={setGroupBy}
            tab={tab}
            onTabChange={setTab}
            measure={measure}
            onMeasureChange={setMeasure}
            basePath={basePath}
          />
        )}
      />
      <Route path="detail" element={<UrgencyDetailView basePath={basePath} sexes={data.options?.sexes ?? NO_SEXES} priorities={data.options?.priorities ?? NO_PRIORITIES} />} />
      <Route path="*" element={<Navigate to={basePath} replace />} />
    </Routes>
  )
}
